
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cf/windows",
      function () {
        return require("private-next-pages/cf/windows.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cf/windows"])
      });
    }
  